import config from "@/constants/config";
import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";

// GeneralViews
import Login from "@/pages/Auth/Login.vue";
import ForgotPassword from "@/pages/Auth/ForgotPassword.vue";
import ResetPassword from "@/pages/Auth/ResetPassword.vue";
import ConfirmAccount from "@/pages/Auth/ConfirmAccount.vue";
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import UserProfile from "@/pages/UserProfile.vue";
import Users from "@/pages/Users.vue";
import LicensePools from "@/pages/LicensePools.vue";
import RequestLicense from "@/pages/RequestLicense.vue";
import Transactions from "@/pages/Transactions.vue";
import Downloads from "@/pages/Downloads.vue";
import Reports from "@/pages/Reports.vue";

import DeviceLinkReport from "@/pages/DeviceLinkReport.vue";
import DeviceLinks from "@/pages/DeviceLinks.vue";
import Enrollments from "@/pages/Enrollments.vue";

import ComputerErased from "@/pages/ComputerErased.vue";
import ComputersErased from "@/pages/ComputersErased.vue";
import DisksErased from "@/pages/DisksErased.vue";
import DiskErased from "@/pages/DiskErased.vue";
import ComputerVerified from "@/pages/ComputerVerified.vue";
import ComputersVerified from "@/pages/ComputersVerified.vue";
import DisksVerified from "@/pages/DisksVerified.vue";
import DiskVerified from "@/pages/DiskVerified.vue";
import MobileDevice from "@/pages/MobileDevice.vue";
import MobileDevices from "@/pages/MobileDevices.vue";

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPassword,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: ResetPassword,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/confirm-account",
    name: "confirm-account",
    component: ConfirmAccount,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/",
    component: DashboardLayout,
    name: "",
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "profile",
        name: "user profile",
        component: UserProfile
      },
      {
        path: "users",
        name: "user management",
        component: Users,
        meta: {
          roles: [
            config.SUPERUSER,
            config.STAFF_USER,
            config.PARTNER,
            config.MANAGER
          ]
        }
      },
      {
        path: "licenses",
        name: "license management",
        component: LicensePools,
        meta: {
          roles: [
            config.SUPERUSER,
            config.STAFF_USER,
            config.PARTNER,
            config.MANAGER
          ]
        }
      },
      {
        path: "request-license",
        name: "request licenses",
        component: RequestLicense
      },
      {
        path: "transactions/:poolId",
        name: "transaction history",
        component: Transactions,
        props: true
      },
      {
        path: "downloads",
        name: "downloads",
        component: Downloads
      },
      {
        path: "reports",
        name: "reports",
        component: Reports,
        meta: {
          roles: [config.SUPERUSER, config.STAFF_USER]
        }
      },
      {
        path: "device-link/reports",
        name: "device link reports",
        component: DeviceLinks
      },
      {
        path: "device-link/reports/:id",
        name: "device link",
        component: DeviceLinkReport,
        props: true
      },
      {
        path: "mobile-devices/",
        name: "mobile device reports",
        component: MobileDevices
      },
      {
        path: "mobile-devices/:mobile_id",
        name: "mobile device",
        component: MobileDevice,
        props: true
      },
      {
        path: "/erased/computers",
        name: "erased computers",
        component: ComputersErased
      },
      {
        path: "/erased/computers/:hardware_id",
        name: "erased computer",
        component: ComputerErased,
        props: true
      },
      {
        path: "/verified/computers",
        name: "verified computers",
        component: ComputersVerified
      },
      {
        path: "/verified/computers/:hardware_id",
        name: "verified computer",
        component: ComputerVerified,
        props: true
      },
      {
        path: "/erased/disks",
        name: "erased disks",
        component: DisksErased
      },
      {
        path: "/erased/disks/:device_id",
        name: "erased disk",
        component: DiskErased,
        props: true
      },
      {
        path: "/verified/disks",
        name: "verified disks",
        component: DisksVerified
      },
      {
        path: "/verified/disks/:device_id",
        name: "verified disk",
        component: DiskVerified,
        props: true
      },
      {
        path: "enrollments",
        name: "enrollments",
        component: Enrollments
      }
    ]
  },
  { path: "*", component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
